export default {
    // API接口基础地址 - 根据环境自动切换
    baseURL: process.env.NODE_ENV === 'development' ? '' : '',

    // API接口路径
    api: {
        // 网站设置相关接口
        settings: {
            public: '/api/settings/public'          // 获取前台公开的网站设置
        },

        // 报告相关接口
        report: {
            search: '/api/reports/search',              // 搜索报告
            detail: '/api/reports',                     // 获取报告详情 /:id
            download: '/api/reports',                   // 下载报告 /:id/download
            preview: '/api/reports'                     // 预览报告 /:id/preview
        }
    }
} 